import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from 'components/ui/dialog';

// ---- a PDF (blob) in a large dialog; the object URL lives as long as the dialog ----
const PdfPreviewDialog: React.FC<{ title: string; blob: Blob | null; onClose: () => void }> = ({ title, blob, onClose }) => {
  const [url, setUrl] = useState<string | null>(null);
  useEffect(() => {
    if (!blob) return;
    const u = URL.createObjectURL(blob);
    setUrl(u);
    return () => URL.revokeObjectURL(u);
  }, [blob]);

  return (
    <Dialog open={!!blob} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="flex h-[92vh] max-w-5xl flex-col gap-3 sm:max-w-5xl">
        <DialogHeader><DialogTitle>{title}</DialogTitle></DialogHeader>
        {url && <iframe title={title} src={url} className="min-h-0 w-full flex-1 rounded border" />}
      </DialogContent>
    </Dialog>
  );
};

export default PdfPreviewDialog;
